/**
 * React 18 entry point. Mounts <App/> into #root and pulls in the
 * design system CSS (pro.css from the locked Claude Design handoff).
 *
 * No additional global styles — the design system is the entire
 * styling surface for this app.
 */
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { loadCompanies } from "@/lib/companyIndex";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import "./styles/pro.css";
import "./styles/alethos.css";
// The semantic bridge must load AFTER both systems: it reads their
// variables, so they have to be defined first (F20).
import "./styles/bridge.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary label="app">
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// Warm the static company list in the background so the first keystroke in any
// search box is answered locally (lib/companyIndex). Failure is harmless: the
// search falls back to the server.
const warmCompanies = () => { void loadCompanies(); };
if (typeof window !== "undefined") {
  const ric = (window as unknown as { requestIdleCallback?: (cb: () => void) => void }).requestIdleCallback;
  if (ric) ric(warmCompanies); else setTimeout(warmCompanies, 300);
}
